module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAKAA0DASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAABwP/xAAlEAACAQMDAgcAAAAAAAAAAAABAgMEBREABgcIEhMhQVFhcZH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AWucOqbdPGPK9zsFHR26e0UkUEyu+PGHfEpZWBPmMsSMe2PtY6buT67mLYNTfq9I4pVuEtKqRLgBUVP05JOfnSZCxIXJJ1cEj10H/2Q=="


//////////////////
// WEBPACK FOOTER
// ./static/Resized_Images/00413r.jpg
// module id = /dbH
// module chunks = 1